module.exports = __webpack_public_path__ + "statics/img/UserReviews-5.93b4d316.png";